<template>
  <div
    v-if="isVisible"
    class="bg-bg-base-bg1 flex items-center rounded-8 p-2 gap-1 hover:bg-bg-base-bg3 group transition-all"
    :class="{
      'bg-bg-base-bg4': $route.name === pathName,
    }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <router-link
      :to="{ name: pathName }"
      class="flex min-w-0 flex-1 items-center overflow-hidden"
    >
      <div class="closable-list-item__content flex min-w-0 flex-1 items-center gap-3">
        <slot name="content" />
      </div>
    </router-link>
    <div class="shrink-0">
      <wui-dropdown
        direction="bottom"
        close-on-click-inside
        close-on-click-outside
        plain
      >
        <template #activator="{ toggle, isActive }">
          <wui-btn
            v-show="isHovered || isActive"
            data-test="closable-list-item-menu"
            class="shrink-0 text-fg-base-fg10!"
            prepend-icon="moreVert"
            variant="neut"
            state="alpha"
            :size="32"
            icon
            @click.stop="toggle()"
          />
        </template>
        <wui-card
          state="text"
          shadow="overflow"
        >
          <wui-list data-test="closable-list-item-menu-list">
            <wui-list-item
              data-test="closable-list-item-hide"
              @click="hideNotification"
            >
              {{ $t('common.hideNotification') }}
            </wui-list-item>
            <wui-list-item
              data-test="closable-list-item-hide-permanently"
              @click="hideNotificationPermanently"
            >
              {{ $t('common.hideNotificationPermanently') }}
            </wui-list-item>
          </wui-list>
        </wui-card>
      </wui-dropdown>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { WuiBtn, WuiCard, WuiDropdown, WuiList, WuiListItem } from '@wui/common-library'
import { ref } from 'vue'

defineProps<{
  isVisible: boolean,
  pathName: string
}>()

const emit = defineEmits<{
  (event: 'close', value: boolean): void
}>()

const isHovered = ref(false)

const hide = (dontShowAnymore: boolean) => {
  emit('close', dontShowAnymore)
}

const hideNotification = () => hide(false)
const hideNotificationPermanently = () => hide(true)
</script>

<style scoped>
.closable-list-item__content :deep(span) {
  min-width: 0;
  flex: 1 1 0%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: none;
}
</style>
